/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_GoalInputs */

const en_lg_guest_goal = /** @type {(inputs: Lg_Guest_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite someone for a limited visit without making them a workspace member. A guest’s display name is not a verified identity.`)
};

const id_lg_guest_goal = /** @type {(inputs: Lg_Guest_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undang seseorang untuk kunjungan terbatas tanpa menjadikannya anggota workspace. Identitas nama tampilan tamu belum diverifikasi.`)
};

/**
* | output |
* | --- |
* | "Invite someone for a limited visit without making them a workspace member. A guest’s display name is not a verified identity." |
*
* @param {Lg_Guest_GoalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_goal = /** @type {((inputs?: Lg_Guest_GoalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_GoalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_goal(inputs)
	return en_lg_guest_goal(inputs)
});